import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Helmet from 'react-helmet'
import Favicon from '@assets/favicon.ico'
import { BSS_URL } from '@constants'

const Seo = ({ title, description, image, url, canonicalUrl }) => (
  <Helmet htmlAttributes={{lang: 'en'}}>
    <link rel='icon' href={`${Favicon}`} />

    {/* General tags */}
    <title>{title}</title>
    <meta name='description' content={description} />
    <meta name='image' content={image} />

    {/* OpenGraph tags */}
    <link rel='canonical' href={R.or(canonicalUrl, url)} />
    <meta property='og:title' content={title} />
    <meta property='og:description' content={description} />
    <meta property='og:image' content={image} />
    <meta property='og:url' content={R.or(url, BSS_URL)} />
    <meta
      http-equiv='Content-Security-Policy'
      content="
        default-src 'self' https://www.gstatic.com https://www.google.com https://www.google-analytics.com/ https://stats.g.doubleclick.net https://apikeys.civiccomputing.com https://o2.mouseflow.com/ https://cc.cdn.civiccomputing.com https://api.dev1.bssindustrial.co.uk https://api.external1.bssindustrial.co.uk https://region1.google-analytics.com https://maps.googleapis.com https://fonts.gstatic.com *.data-crypt.com;
        img-src 'self' http://localhost:8000 data: http://images.ctfassets.net https://downloads.ctfassets.net https://maps.google.com/ https://maps.gstatic.com/ https://maps.googleapis.com/  www.google-analytics.com www.force24.co.uk *.data-crypt.com www.googletagmanager.com;
        script-src 'self' 'unsafe-inline' 'unsafe-eval' blob: https://www.google.com www.google-analytics.com https://ajax.googleapis.com https://cdn.mouseflow.com https://tracking1.force24.co.uk https://maps.googleapis.com www.force24.co.uk *.data-crypt.com www.googletagmanager.com https://www.gstatic.com https://cc.cdn.civiccomputing.com http://cdnjs.cloudflare.com ;
        style-src 'self' 'unsafe-inline' blob: https://fonts.googleapis.com ;
        frame-src 'self' https://docs.google.com https://www.google.com https://bim-warehouse.co.uk https://www.youtube.com/;
    " />

    <script src='https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js' type='text/javascript' defer />
    <script type='text/javascript'>
      {`
        window.onload  = function() { 
          var configuration = {
            apiKey: 'fb4e26924daf3142092a8761d5dad91638cf99ba',
            product: 'PRO_MULTISITE',
            initialState: "notify",
            setInnerHTML: true,
            text: {
                settings: 'Manage Cookies',
                reject: 'Reject All',
                accept: 'Accept All',
                rejectSettings: 'Reject All',
                acceptSettings: 'Accept All',
                intro: 'By clicking “Accept All Cookies”, you agree to the storing of cookies on your device to enhance site navigation, analyse site usage, and assist in our marketing efforts. We will not set optional cookies unless you enable them. You can use this tool to set a cookie on your device to remember your preferences. For more detailed information about the cookies we use, see our <a href="/cookies-policy" style="text-decoration:underline">Cookie Policy</a>',
                notifyDescription: 'We use cookies to optimise site functionality and give you the best possible experience. <a href="/cookies-policy" style="text-decoration:underline">Cookie Policy</a>'
            },
            necessaryTitle: 'Strictly Necessary Cookies',
            necessaryDescription: 'These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.',
            necessaryCookies: ['_dc_gtm_${process.env.GATSBY_GOOGLE_ANALYTICS_ID}'],
            optionalCookies: [{
                    name: 'performance',
                    label: 'Performance Cookies',
                    description: 'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.',
                    cookies: ['_gat', '_gid', '_ga', 'mf_user', 'mf_52314aec-20a3-4574-b8a3-ea4034771830'],
                    onAccept: function () { dataLayer.push({'event': 'analytics_consent_given'}); },
                },
                {
                    name: 'targeting',
                    label: 'Targeting Cookies',
                    description: 'These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information, but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising.',
                    thirdPartyCookies: [{
                        'name': 'NID',
                        'optOutLink': 'https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=en'
                    }, {
                        'name': '_region',
                        'optOutLink': 'https://bim-warehouse.co.uk/privacy-policy'
                    }, {
                        'name': 'device_view',
                        'optOutLink': 'https://bim-warehouse.co.uk/privacy-policy'
                    }]
                },
                {
                    name: 'functional',
                    label: 'Functional Cookies',
                    description: 'These cookies enable the website to provide enhanced functionality and personalisation. They may be set by us or by third party providers whose services we have added to our pages. If you do not allow these cookies then some or all of these services may not function properly.',
                    cookies: [],
                    thirdPartyCookies: [{
                        'name': 'S',
                        'optOutLink': 'https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=en'
                    }]
                }
            ]
          };
          CookieControl.load(configuration); 
        };
      `}
    </script>
  </Helmet>
)

Seo.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string,
  url: PropTypes.string
}

export default Seo



// WEBPACK FOOTER //
// ./src/components/Seo/Seo.js